import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { SessionService } from 'src/app/auth/session.service';
import { promiseWithCatch } from '../../app.helpers';

@Injectable()
export abstract class GuardShared {
  protected sessionService = inject(SessionService);
  protected router = inject(Router);

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkGuard(state.url, route);
  }

  public canLoad(_route: Route, segments: UrlSegment[]): boolean {
    return this.checkGuard(`/${segments.map((segment: UrlSegment) => segment.path).join('/')}`);
  }

  public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  protected abstract checkGuard(previousPage?: string, route?: ActivatedRouteSnapshot): boolean;

  protected sharedCheckGuard(previousPage: string): boolean {
    if (!this.sessionService.isSessionActive()) {
      promiseWithCatch(
        this.router.navigateByUrl('/login', {
          skipLocationChange: true,
          state: { previousPage },
        }),
      );
    }

    return this.sessionService.isSessionActive();
  }

  protected isSessionActive(): boolean {
    return this.sessionService.isSessionActive();
  }
}
